import React from 'react';

import { Icon } from '@rbilabs/universal-components';

import { FavoriteIcon } from 'components/favorite-icon';
import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';

import { StoreCardActionsContainer } from './store-card-actions.styled';
import { StoreCardButton } from './store-card-button';

interface StoreCardActionsProps {
  onDiagnosticsClick?: () => void;
  onFavoritesClick?: () => void;
  onInfoPress?: () => void;
  isUpdatingFavorites?: boolean;
  isFavorite?: boolean;
  canBeSelected: boolean;
  containerStyle?: any;
}

export const StoreCardActions: React.FC<StoreCardActionsProps> = ({
  onDiagnosticsClick,
  onFavoritesClick,
  onInfoPress,
  isUpdatingFavorites,
  isFavorite,
  canBeSelected,
  containerStyle,
}) => {
  const { isAuthenticated } = useAuthContext();

  return (
    <StoreCardActionsContainer {...containerStyle}>
      {onDiagnosticsClick && (
        <StoreCardButton
          testID="store-favorite-button"
          accessibilityLabel="Open a diagnostic modal for this store"
          onPress={onDiagnosticsClick}
          icon={<Icon variant="settings" />}
        />
      )}
      {onInfoPress && canBeSelected && (
        <StoreCardButton
          accessibilityLabel={t('info')}
          onPress={onInfoPress}
          icon={<Icon size="$5" variant="info" aria-hidden />}
        />
      )}
      {isAuthenticated && onFavoritesClick && (
        <StoreCardButton
          accessibilityLabel={isFavorite ? t('removeFavorite') : t('setRestaurantAsFavorite')}
          onPress={onFavoritesClick}
          icon={<FavoriteIcon loading={isUpdatingFavorites} isFavorite={isFavorite} />}
          isDisabled={isUpdatingFavorites}
        />
      )}
    </StoreCardActionsContainer>
  );
};
